define('plugin/google-tag-manager/GoogleTagManagerPlugin',['require','lib/plugin/PluginAbstract','cookieblock'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var CookieBlock = require('cookieblock');

    return PluginAbstract.extend({

        initialize: function () {
            this._initCookieBlock();
        },

        _initCookieBlock: function () {

                if (allowCookies) {
                    // do nothing - it's automatic
                } else if (!cookiesAccepted) {
                    CookieBlock.addAcceptedHandler(function () {
                        location.reload();
                    });

                    //NB defer showing cookie block until page (and cookie block in particular) is rendered
                    setTimeout(function () {
                        CookieBlock.show();
                    }, 0);
                }

        }

    });

});

